'use client';

import React, { useCallback } from 'react';
import InlineTextInput from '@frontend/jetlend-web-ui/src/ui/inputs/InlineTextInput/InlineTextInput';
import connectToForm from '@frontend/jetlend-core/src/ducks/connectToForm';
import { withDebounce } from '@frontend/jetlend-core/src/async/debounce';
import Loader from '@frontend/jetlend-web-ui/src/ui/loaders/Loader';
import { commonValidationPromoCodeFormHandler } from '@app/ducks/common/registration';

/**
 * Компонент шага процесса авторизации для ввода промокода.
 */
export default connectToForm(function StepPromoCodeForm({
    formSubmitting,
    handleSubmit,
}) {
    const didChanged = useCallback(withDebounce(async () => {
        handleSubmit();
    }, { timeout: 500 }), []);

    return (
        <InlineTextInput
            name="promocode"
            label="Промокод"
            inputType="text"
            onChange={didChanged}
            noMarginBottom
            footer={formSubmitting && (
                <div className="d-flex d-flex--v-center d-flex--gap-10">
                    <Loader size="small" />
                    Загрузка...
                </div>
            )}
        />
    );
}, commonValidationPromoCodeFormHandler);
